import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Box, Typography } from 'shared/ui'
import { useRcsCreateContext } from 'pages/settings/pages/rcs/context/rcsCreateContext'
import { type IRcsPreviewTabs } from 'pages/settings/pages/rcs/store/type'
import { RcsConversationPreview } from './RcsConversationPreview/RcsConversationPreview'
import { RscProfilePreview } from './RscProfilePreview/RscProfilePreview'

import styles from './styles.module.scss'

export const RcsCreatePreview = observer(() => {
  const { previewTabs, activeTab, setActiveTab } = useRcsCreateContext()
  return (
    <Box width={'100%'}>
      <div className={styles.preview__tabs}>
        {previewTabs.map((tab) => (
          <div
            key={tab.value}
            className={classNames(styles.preview__tab, {
              [styles.active]: activeTab === tab.value,
            })}
            onClick={() => setActiveTab(tab.value as IRcsPreviewTabs)}
          >
            <Typography
              ariaLabel='name'
              variant='button-small'
              color={
                activeTab === tab.value
                  ? 'var(--content-primary-primary)'
                  : 'var(--content-primary-tertiary)'
              }
            >
              {tab.label}
            </Typography>
          </div>
        ))}
      </div>
      <Box padding={'48px 63px'}>
        {activeTab === 'profile' && <RscProfilePreview />}
        {activeTab === 'conversation' && <RcsConversationPreview />}
      </Box>
    </Box>
  )
})
